import { render, staticRenderFns } from "./VideoManagement.vue?vue&type=template&id=56fe7b98&scoped=true&"
import script from "./VideoManagement.vue?vue&type=script&lang=js&"
export * from "./VideoManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe7b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fe7b98')) {
      api.createRecord('56fe7b98', component.options)
    } else {
      api.reload('56fe7b98', component.options)
    }
    module.hot.accept("./VideoManagement.vue?vue&type=template&id=56fe7b98&scoped=true&", function () {
      api.rerender('56fe7b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/VideoManagement.vue"
export default component.exports